module.exports = __webpack_public_path__ + "img/gps.a6dcadec.svg";